import { stCol } from 'skin/dict/content/main/fn';
import './style.css';

const Col = (props) => {
	let cls = ['skin-dct-cnt-main-body-row-col', 'dct-cnt-main-body-row-col'];
	cls = cls.join(' ');
	const st = {}
	const name = props.type === '' ? 'itm' : props.type;
	if (props.item === props.label) {
		st.backgroundImage = `url(skin/img/dct_${name}.svg)`;
		st.paddingLeft = '20px';
	}
	const val =
		typeof props.data === 'boolean' ? props.data.toString() : props.data;
		const stDiv = stCol(props.width, props.item)
	const url = isUrl(val)
	return (
		<td className={cls} style={st} >
			{
				url? <img src={val} style={stDiv} title={val}/>
				:<div title = {val} style = {stDiv} >{val}</div>}
		</td>
	);
};

export default Col;


function isUrl(str) {
	const urlPattern = /^http[s]?:\/\//i;
    const winPathPattern = /^[C-Z]:[\/\\]/i; // C:/ или C:\ и т.д.
    return urlPattern.test(str) || winPathPattern.test(str);
}